const API_BASE = process.env.REACT_APP_API_URL;

const buildApiUrl = (path, params) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const url = new URL(normalizedPath, API_BASE);

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry !== undefined && entry !== null && entry !== "") {
          url.searchParams.append(key, entry);
        }
      });
      return;
    }

    url.searchParams.append(key, value);
  });

  return url.toString();
};

const readResponseBody = async (response, responseType) => {
  if (responseType === "blob") {
    return response.blob();
  }

  if (responseType === "text") {
    return response.text();
  }

  const text = await response.text();
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
};

const createApiError = (response, data) => ({
  response: {
    data,
    status: response.status,
    headers: Object.fromEntries(response.headers.entries()),
  },
  status: response.status,
});

const apiFetch = async (
  path,
  { method = "GET", params, body, headers = {}, responseType = "json" } = {}
) => {
  const token = localStorage.getItem("access_token");
  const requestHeaders = new Headers(headers);

  if (token) {
    requestHeaders.set("Authorization", `Bearer ${token}`);
  }

  let requestBody = body;
  if (
    body !== undefined &&
    body !== null &&
    !(body instanceof FormData) &&
    typeof body !== "string"
  ) {
    requestHeaders.set("Content-Type", "application/json");
    requestBody = JSON.stringify(body);
  }

  const response = await fetch(buildApiUrl(path, params), {
    method,
    headers: requestHeaders,
    body: requestBody,
  });

  const data = await readResponseBody(response, responseType);

  if (!response.ok) {
    throw createApiError(response, data);
  }

  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
    status: response.status,
  };
};

export { API_BASE, apiFetch, buildApiUrl };
